import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerDetailsComponent } from './customer-details.component';
import { BookingSummarySettingsComponent } from './booking-summary-settings.component';
import { OrganisationActivationControlComponent } from './organisation-activation-control/organisation-activation-control.component';

const routes: Routes = [{ path: '', component: CustomerDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerDetailsRoutingModule {}

@NgModule({
  imports: [
    CustomerDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [
    CustomerDetailsComponent,
    BookingSummarySettingsComponent,
    OrganisationActivationControlComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerDetailsModule {}
